import React from 'react';
import { Col, Row, Spin } from 'antd';
import clsx from 'clsx';
import { Select } from 'antd';
import LoaderAnimation from 'shared/components/LoaderAnimation';
import MyLineChart from './LineChart';
import { CompanyDashboardProps } from './constants';
import { truncateWithEllipsis } from 'shared/utils/truncateWithElipsis';
import styles from './company.module.scss';
import { ReactComponent as Arrow } from 'assets/icons/arrow.svg';
import { YoYEmission } from 'models/MainDashboard/yoyModel.model';
import { SbtiDashboardResponse } from 'models/Sbti/sbtiYoy.model';

const { Option } = Select;

interface YoYEmissionChartProps {
  yoyData: SbtiDashboardResponse | undefined;
  selectedTarget: string;
  handleSelectChange: (value?: string) => void;
  loadLine: boolean;
  yearEmissionLoading: boolean;
  paginatedYoYEmission: YoYEmission[] | undefined;
  locationOption: string;
  maxSbtiCO2e: number;
  firstYear: string;
  fetchYoYEmissions: (params: {
    organizationId: number;
    locationId?: number;
    targetName?: string;
    year?: number;
    exportType?: string;
  }) => Promise<void>;
  parentID: number;
}

const YoYEmissionChart: React.FC<YoYEmissionChartProps> = ({
  yoyData,
  selectedTarget,
  handleSelectChange,
  loadLine,
  yearEmissionLoading,
  paginatedYoYEmission,
  locationOption,
  maxSbtiCO2e,
  firstYear,
  fetchYoYEmissions,
  parentID,
}) => {
  return (
    <div className={styles.yoyEmissionArea}>
      <div className={styles.scopeDropdownArea}>
        <Row align="bottom" justify="space-between">
          <Col span={15}>
            <h5 className={clsx(styles.yoyEmissionTitle, styles.extraMargin)}>
              {CompanyDashboardProps.YOY_TEXT}
            </h5>
          </Col>
          <Col className={styles.extraMargin} span={9}>
            {yoyData?.sbtiTargetList?.length !== 0 && (
              <Select
                allowClear={
                  selectedTarget !== CompanyDashboardProps.SELECT_TARGET
                }
                suffixIcon={<Arrow fontSize={44} />}
                value={selectedTarget || CompanyDashboardProps.SELECT_TARGET}
                listHeight={120}
                onChange={handleSelectChange}
                className={styles.overlay}
                placeholder="Select Target">
                {yoyData?.sbtiTargetList?.map(
                  (target: { targetName?: string }) =>
                    target.targetName && (
                      <Option key={target.targetName} value={target.targetName}>
                        {truncateWithEllipsis(target.targetName)}
                      </Option>
                    )
                )}
              </Select>
            )}
          </Col>
        </Row>
      </div>
      <Spin spinning={loadLine} tip="Loading">
        <div className={styles.cardContainer}>
          <div className={styles.breakdownChart}>
            {yearEmissionLoading ? (
              <div className={styles.loaderContainer}>
                <LoaderAnimation />
              </div>
            ) : (
              <MyLineChart
                AxisProp={CompanyDashboardProps.YEAR}
                unit={CompanyDashboardProps.TCO2}
                data={paginatedYoYEmission}
                isTwoLine={
                  selectedTarget !== CompanyDashboardProps.SELECT_TARGET
                }
                locationId={locationOption}
                targetName={selectedTarget}
                maxSbtiValue={maxSbtiCO2e}
                selectedYear={Number(firstYear)}
                fetchYoYEmissions={fetchYoYEmissions}
                orgId={Number(parentID)}
                height={400}
              />
            )}
          </div>
        </div>
      </Spin>
    </div>
  );
};

export default YoYEmissionChart;
